export var scales = {
    MD: "md",
    SM: "sm",
    XS: "xs"
};
export var variants = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    TERTIARY: "tertiary",
    TEXT: "text",
    DANGER: "danger",
    SUBTLE: "subtle",
    SUCCESS: "success",
    LIGHT: "light",
    CONTAINED: "contained"
};
